module.exports = ".row{\r\n    padding:37px 0px 0px;\r\n}\r\n\r\n.row:nth-child(odd){\r\n    background: #f3f3f3;\r\n}\r\n\r\n.margin-top{\r\n    margin-top: 24px;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/hrms/payroll/emp-salary-details/fixed-deductions/fixed-deduction-grid/fixed-deduction-grid.component.css
// module id = ./src/app/hrms/payroll/emp-salary-details/fixed-deductions/fixed-deduction-grid/fixed-deduction-grid.component.css
// module chunks = main